import React from "react";
import { loadEmailPreviews, replaceHref, subButtons, getRightButtons } from "./utils";
import Button from 'storybookComponents/Button';
import LeftButtonsMenu from "./components/leftmenu";
import EmailPreview from "./components/emailPreview";
import SharePreview from "./components/sharePreview";
import ResidentialPortal from "./components/residentialPortal";
import EnrollForm from "./components/enrollForm";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Loader from "storybookComponents/Loader";
import DirectLink from "./components/DirectLink"
import * as path from "constants/path";
import { getUtmLinks } from "../util";
import "./index.css"

var allPreviews = {};

const ResidentInvite = ({ index, mobileView, smsView, allData, emailHtml, subject, enrollUrl, orgColors }) => {
  return (
    <>

      <>
        {
          index == 0 ?
            <EmailPreview
              html={emailHtml}
              subject={subject}
              mobileView={mobileView}
              {...allData}
              smsView={smsView}
              smsImage={allData.image}
              smsContent={allData.emailSms}
              orgColors={orgColors}
            />
            : index == 1 ? <ResidentialPortal mobileView={mobileView} orgColors={orgColors} {...allData} /> :
              index == 2 ? < DirectLink enrollUrl={enrollUrl} /> : null
        }
      </>
    </>
  )
}


export default React.memo(({ classes, id, values, setTitle, enrollUrl, orgColors, title }) => {
  const [utmCodesLink, setUtmCodeLink] = React.useState();

  React.useEffect(async () => {
    setTitle([
      { "label": "Referral Campaigns", "link": path.getAppPath(), "active_state": false }, { "label": title, "link": "#", "active_state": false },
    ])
  }, [])

  const [emailPreviews, setEmailPreviews] = React.useState()
  const [emailSubject, setEmailSubject] = React.useState()
  const [viewId, setViewId] = React.useState([]);
  const [activeSubButton, setActiveSubButton] = React.useState(1);
  const [activeTab, setActiveTab] = React.useState(0);
  const [allData, setAllData] = React.useState();
  const [disableSms, setDisableSms] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [subOption, setSubOption] = React.useState(0);

  const updateSubButtons = (data) => {
    setActiveTab(data)
    switch (data) {
      case 0:
        setDisableSms(false)
        setEmailSubject(allPreviews.emailSubject)
        setEmailPreviews(allPreviews.residentInviteEmailCampaignHtml);
        setSubOption(0);
        break;
      case 2:
        setEmailSubject(allPreviews.residentThankYouEmailSubject)
        setEmailPreviews(allPreviews.residentEnrollEmailCampaignHtml);
        break;
      case 3:
        setSubOption(0);
        setEmailSubject(allPreviews.residentInviteEmailSubject)
        setEmailPreviews(allPreviews.friendInviteEmailCampaignHtml);
        break;
      case 4:
        setEmailSubject(allPreviews.residentDiscountEmailSubject)
        setEmailPreviews(allPreviews.residentRewardInviteEmailCampaignHtml);
        break;
    }
  }

  const onSubButtonClick = (data) => {
    setActiveSubButton(data.index)
  }

  const init = async () => {
    updateSubButtons(0)
    let utmLink = await getUtmLinks(id);
    if (utmLink) {
      setUtmCodeLink(utmLink)
    }

    setLoading(true)
    allPreviews = await loadEmailPreviews(id);
    console.log("allPreviews", allPreviews.residentEnrollEmailCampaignHtml)
    console.log("enroll", allPreviews.residentInviteEmailCampaignHtml)
    setLoading(false)
    if (!allPreviews) return;
    setEmailPreviews(allPreviews.residentInviteEmailCampaignHtml);
    setEmailSubject(allPreviews.emailSubject);
    setAllData(allPreviews)
  }

  const onResidentialOptionChange = (index) => {
    setDisableSms(index == 1)
  }

  React.useEffect(init, [1]);

  const onSubOptionChange = (value) => {
    //setDisableSms(value == 1)
    setSubOption(value)
  }

  let rightButtons = getRightButtons(activeTab, subOption)
  if (loading) return <Loader />
  if (!allData) return null;

  const allViews = [{
    name: "A. Resident Invite",
    id: 0,
    children: [
      {
        id: 0,
        name: "1. Via Email/SMS",
        active: true,
      }, {
        id: 1,
        name: "2. Via Resident Portal",
        active: true,
      },
      {
        id: 2,
        name: "3. Via Direct Link",
        active: true,
      }
    ]
  }, {
    name: "B. Enroll Form",
    id: 1
  },
  {
    name: "C. Thank You email",
    id: 2
  },
  {
    name: "D. Friend Invite",
    id: 3,
    children: [
      {
        id: 0,
        name: "1. Share Options",
        active: true,
      },
      {
        id: 1,
        name: "2. Email",
        active: true,
      },
      {
        id: 2,
        name: "3. Confirmation",
        active: true,
      },
    ]
  }, {
    name: "E. Resident Reward",
    id: 4
  }]


  return (
    <div id="previewContainerHyRaf">
      <Box className={classes.buttonGroup}>
        {rightButtons.map((button, index) => (
          <Box key={button.index} className={classes.buttonContainer}>
            {
              activeSubButton == button.index
            }
            <Button
              variant="tertiary"
              state={activeSubButton == button.index}
              onClick={onSubButtonClick.bind(this, button)}
              className={`${activeSubButton == button.index ? classes.activeButton : classes.inactiveButton}`}
            >
              {button.label}
            </Button>
            {index !== rightButtons.length - 1 && (
              <Divider orientation="vertical" />
            )}
          </Box>
        ))}
      </Box>
      <LeftButtonsMenu list={allViews} onSubOptionChange={onSubOptionChange} onChange={updateSubButtons} />
      <div className={classes.previewContainer}>

        {
          activeTab == 0 &&
          <ResidentInvite
            index={subOption}
            mobileView={activeSubButton == 2}
            smsView={activeSubButton == 3}
            allData={allData}
            emailHtml={replaceHref(emailPreviews, utmCodesLink.directLink)}
            subject={emailSubject}
            enrollUrl={utmCodesLink && utmCodesLink.directLink}
            orgColors={orgColors}
          />
        }

        {
          activeTab == 1 &&
          <EnrollForm mobileView={activeSubButton == 2} orgColors={orgColors} {...allData} />
        }
        {
          activeTab == 2 && allData &&
          <EmailPreview
            html={emailPreviews}
            subject={emailSubject}
            {...allData}
            mobileView={activeSubButton == 2}
            orgColors={orgColors}
          />
        }

        {
          activeTab == 3 &&
          <SharePreview
            index={subOption}
            mobileView={activeSubButton == 2}
            smsView={activeSubButton == 3}
            viewShareOptions={viewId === 3}
            orgColors={orgColors}
            html={emailPreviews}
            subject={emailSubject}
            smsImage={allData.residentInviteImage}
            smsContent={allData.residentInviteSmsParsed}
            {...allData} />
        }

        {/* {
          activeTab == 4 && allData &&
          <EmailPreview
            html={emailPreviews}
            subject={emailSubject}
            {...allData}
            mobileView={activeSubButton == 2}
            smsView={activeSubButton == 3}
            smsImage={allData.residentInviteImage}
            smsContent={allData.residentInviteSmsParsed}
            orgColors={orgColors}
          />
        } */}

        {
          activeTab == 4 && allData &&
          <EmailPreview
            html={emailPreviews}
            subject={emailSubject}
            {...allData}
            mobileView={activeSubButton == 2}
            smsView={activeSubButton == 3}
            smsImage={allData.residentDiscountImage}
            smsContent={allData.residentDiscountEmailSms}
            orgColors={orgColors}
          />
        }

      </div>
    </div >
  )
})